import { render, staticRenderFns } from "./cockpit.vue?vue&type=template&id=0684add2&"
import script from "./cockpit.vue?vue&type=script&lang=js&"
export * from "./cockpit.vue?vue&type=script&lang=js&"
import style0 from "./cockpit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports